export default __webpack_public_path__ + "static/media/united_states.46646437.svg";